/* global google */
/**
 *
 */
export const initMap = () => {

	const mapElement = document.getElementById( 'googleMap' )
	const address = mapElement.getAttribute( 'data-address' )
	const googleMapUrl = mapElement.getAttribute( 'data-google-map-url' )
	const markerNewTabTarget = mapElement.getAttribute( 'data-google-marker-target' )
	const pinIcon = mapElement.getAttribute( 'data-pin-icon' )
	const geocoder = new google.maps.Geocoder()
	const options = {
		zoom: 14,
		zoomControl: false,
		disableDefaultUI: true,
	};

	const icon = {
		url: pinIcon,
		scaledSize: new google.maps.Size( 50, 50 ),
	};

	const map = new google.maps.Map( document.getElementById( 'googleMap' ), options );

	geocoder.geocode( { address: address }, function handleGeocoder ( results, status ) {

		if ( status === 'OK' ) {

			map.setCenter( results[ 0 ].geometry.location );
			const marker = new google.maps.Marker( {
				map: map,
				position: results[ 0 ].geometry.location,
				icon: icon,

			} );

			if ( googleMapUrl ) {

				google.maps.event.addListener( marker, 'click', function handleMarkerClick() {

					window.open( googleMapUrl, ( markerNewTabTarget === 'true' ) ? '_blank' : '_self' )

				} );

			}

		} else {

			/* eslint-disable no-console */
			console.log( `Geocode was not successful for the following reason: ${ status }` );
			/* eslint-enable no-console */

		}

	} );

}
